import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { hideLoader, showLoader } from '../../components/Loader/loaderSlice';
import { CreateEditModal, Notifications, TableDropdownButton } from '../../components';
import ListTable, { ColumnProps } from '../../components/ListTable';
import CreateEditPage from './CreateEditPage';
import { RegionsService, NotificationsService } from '../../services';
import { Region } from '../../@types/region';
import { useDataMatch } from '../../hooks';

const RegionPage: React.FC<PropTypes> = ({ match, history }) => {
  const dispatch = useDispatch();
  const [regions, setRegions] = useState<Region[]>([]);
  const [dropdownOpened, setDropdownOpened] = useState('');
  const [modalVisible, setModalVisible] = useState(false);
  const isCreatingEditing = useDataMatch(match.params.action, ['novo', 'editar']);

  const deleteNotification = (id: string, description: string) => NotificationsService.custom({
    message: <Notifications.Button
      text={<>Você tem certeza que deseja excluir <b>{description}</b>?</>}
      onClickYes={() => onConfirmDelete(id)}
    />,
  });

  const onConfirmDelete = async (id: string) => {
    try {
      await RegionsService.remove(id);
      loadRegions();
    } catch (error) {
      console.error(error);
      NotificationsService.error({ message: 'Falha ao excluir Região' });
    }
  };

  const columns: ColumnProps<Region>[] = [{
    field: 'description',
    header: 'Descrição',
  },
  {
    field: 'uf',
    header: 'UF',
  },
  {
    header: '',
    body: ({ description, uuid, id }: Region) => (
      <TableDropdownButton
        isActive={dropdownOpened === uuid}
        onClickOver={() => setDropdownOpened('')}
        onClickDropdownButton={() => setDropdownOpened(dropdownOpened ? '' : uuid)}
        redirectOnClickEdit={`/regioes/editar/${id}`}
        onClickDelete={() => deleteNotification(id, description)}
      />
    ),
    sortable: false,
    className: 'options-column',
  }];

  const loadRegions = async () => {
    dispatch(showLoader());
    try {
      setRegions(await RegionsService.find(''));
    } catch (error) {
      NotificationsService.error({ message: 'Falha ao carregar Lista de Regiões' });
      console.error(error);
    } finally {
      dispatch(hideLoader());
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { loadRegions(); }, []);

  useEffect(() => {
    setModalVisible(isCreatingEditing);
  }, [isCreatingEditing]);

  return (
    <div className="regions">
      <div className="page-title">
        <h1 className="title">Regiões</h1>
      </div>
      <div>
        <div className="buttons is-right">
          <p className="control">
            <Link className="button is-link" to="/regioes/novo">Adicionar Região</Link>
          </p>
        </div>
        <CreateEditModal
          visible={modalVisible}
          onClose={() => setModalVisible(false)}
          onClosed={() => history.push('/regioes')}
          title={`${match.params.id ? 'Edição' : 'Criação'} de Região`}
        >
          <CreateEditPage
            id={match.params.id}
            onClose={() => setModalVisible(false)}
            onSave={loadRegions}
          />
        </CreateEditModal>
        <ListTable
          columns={columns}
          data={regions}
          showUUID
        />
      </div>
    </div>
  );
};

export default RegionPage;

type PropTypes = RouteComponentProps<RouteParams>;

type RouteParams = {
  action?: 'novo' | 'editar',
  id?: string,
};
